import React from "react";
import { Grid, Box, Typography, Link, Container, useTheme, alpha } from "@mui/material";
import { useSettingsContext } from "../settings";
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

export default function Footer() {
  const theme = useTheme();
  const settings = useSettingsContext();

  return (
    <Box
      component="footer"
      sx={{
        position: 'relative',
        bgcolor: theme.palette.mode === 'light' 
          ? alpha(theme.palette.grey[200], 0.8) 
          : alpha(theme.palette.grey[800], 0.8),
        py: 6,
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo ve Açıklama */}
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 3 }}>
              <img
                src={theme.palette.mode === 'light' 
                  ? "/img/adventureLogo.png"
                  : "/img/adventureLogoDark.png"}
                alt="Logo"
                style={{ height: "40px" }}
              />
            </Box>
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 2,
                color: theme.palette.mode === 'light' 
                  ? theme.palette.text.secondary 
                  : theme.palette.text.disabled 
              }}
            >
              Söğütözü Mahallesi <br /> Söğütözü Caddesi No: 2A / 58 <br /> Çankaya / Ankara
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                mb: 1,
                color: theme.palette.mode === 'light' 
                  ? theme.palette.text.secondary 
                  : theme.palette.text.disabled 
              }}
            >
              +90 (312) 502 02 73
            </Typography>
            <Link
              href="mailto:kitlefonlama@ardventure.com.tr"
              variant="body2"
              sx={{
                color: theme.palette.primary.main,
                '&:hover': {
                  color: theme.palette.primary.dark,
                  textDecoration: 'none',
                },
              }}
            >
              kitlefonlama@ardventure.com.tr
            </Link>
            <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
              <Link
                href="https://instagram.com/ardventure"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#E4405F',
                  '&:hover': {
                    color: alpha('#E4405F', 0.8),
                  },
                }}
              >
                <InstagramIcon />
              </Link>
              <Link
                href="https://twitter.com/ardventure"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#1DA1F2',
                  '&:hover': {
                    color: alpha('#1DA1F2', 0.8),
                  },
                }}
              >
                <TwitterIcon />
              </Link>
              <Link
                href="https://linkedin.com/company/ardventure"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: '#0A66C2',
                  '&:hover': {
                    color: alpha('#0A66C2', 0.8),
                  },
                }}
              >
                <LinkedInIcon />
              </Link>
            </Box>
          </Grid>

          {/* Kurumsal Menü */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={{ mb: 2.5, color: theme.palette.text.primary }}>
              Kurumsal
            </Typography>
            {["Hakkımızda", "Yönetim Kurulu", "Yatırım Komitesi", "Ekibimiz", "Basın Odası", "IK Başvuru Formu", "İletişim"].map((item) => (
              <Link
                key={item}
                href="#"
                variant="body2"
                sx={{
                  display: 'block',
                  mb: 1,
                  color: theme.palette.mode === 'light' 
                    ? theme.palette.text.secondary 
                    : theme.palette.text.disabled,
                  '&:hover': {
                    color: theme.palette.primary.main,
                    textDecoration: 'none',
                  },
                }}
              >
                {item}
              </Link>
            ))}
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={{ mb: 2.5, color: theme.palette.text.primary }}>
              Politikalar
            </Typography>
            {[
              "Kalite, Bilgi Güvenliği",
              "Kara Para ile Mücadele",
              "Rüşvet ve Yolsuzluk ile Mücadele",
              "Genel Risk Bildirimi",
              "Belgelerimiz",
            ].map((item) => (
              <Link
                key={item}
                href="#"
                variant="body2"
                sx={{
                  display: 'block',
                  mb: 1,
                  color: theme.palette.mode === 'light' 
                    ? theme.palette.text.secondary 
                    : theme.palette.text.disabled,
                  '&:hover': {
                    color: theme.palette.primary.main,
                    textDecoration: 'none',
                  },
                }}
              >
                {item}
              </Link>
            ))}
          </Grid>

          {/* Yasal Menü */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={{ mb: 2.5, color: theme.palette.text.primary }}>
              Bildirimler
            </Typography>
            {[
              "Kamuyu Aydınlatma",
              "Ücretler ve Kesintiler",
              "Üyelik Sözleşmesi",
              "Kampanya Sözleşmesi",
              "KVKK Bildirimi",
              "Genel Risk Bildirimi",
              "Sermaye Piyasası Kurulu"
            ].map((item) => (
              <Link
                key={item}
                href="#"
                variant="body2"
                sx={{
                  display: 'block',
                  mb: 1,
                  color: theme.palette.mode === 'light' 
                    ? theme.palette.text.secondary 
                    : theme.palette.text.disabled,
                  '&:hover': {
                    color: theme.palette.primary.main,
                    textDecoration: 'none',
                  },
                }}
              >
                {item}
              </Link>
            ))}
            
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" sx={{ mb: 2.5, color: theme.palette.text.primary }}>
              Üyelikler
            </Typography>
            {[
              "Merkezi Kayıt Kuruluşu",
              "Takasbank",
              "Sermaye Piyasası Kurulu",
            ].map((item) => (
              <Link
                key={item}
                href="#"
                variant="body2"
                sx={{
                  display: 'block',
                  mb: 1,
                  color: theme.palette.mode === 'light' 
                    ? theme.palette.text.secondary 
                    : theme.palette.text.disabled,
                  '&:hover': {
                    color: theme.palette.primary.main,
                    textDecoration: 'none',
                  },
                }}
              >
                {item}
              </Link>
            ))}
          </Grid>

          {/* İletişim */}
        </Grid>

        {/* Copyright */}
        <Box 
          sx={{ 
            pt: 4, 
            mt: 4, 
            borderTop: `1px solid ${theme.palette.divider}`,
            textAlign: 'center' 
          }}
        >
          <Typography 
            variant="body2"
            sx={{ 
              color: theme.palette.mode === 'light' 
                ? theme.palette.text.secondary 
                : theme.palette.text.disabled 
            }}
          >
            © {new Date().getFullYear()} Ardventure. Tüm hakları saklıdır.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}